import {NgModule} from '@angular/core';
import {SharedModule} from '../shared/shared.module';
import {RoomDatatableComponent} from './room-datatable.component';
import {RoomService} from './room.service';
import {RoomFormComponent} from './room-form.component';

@NgModule({
  declarations: [
    RoomDatatableComponent,
    RoomFormComponent
  ],
  exports: [
    RoomDatatableComponent,
    RoomFormComponent
  ],
  imports: [
    SharedModule
  ],
  providers: [
    RoomService
  ]
})
export class RoomModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/room/room.module.ts